import React from "react";
import CustomTable from "../customTable";
import Comments from "../comments";

// Import ResultsPerProductColumns from the ResultsPerProduct component
// or define it directly if needed
const ResultsPerCategoryColumns = [
  { header: "Category", accessor: "category" },
  // We'll need to slice from ResultsPerProductColumns, but since we're defining
  // these columns in separate files now, we'll include all the necessary columns directly
  { header: "Orders", accessor: "Gross_Orders", total_key: "total_orders" },
  { header: "Cost", accessor: "totalCost", total_key: "total_totalCost" },
  { header: "Sales", accessor: "grossSales", total_key: "total_grossSales" },
  { header: "NetSales", accessor: "netSales", total_key: "total_netSales" },
  { header: "Refunds Count", accessor: "refunds_count", total_key: "total_refunds_count" },
  { header: "Refund rate%", accessor: "refundRatePercent", total_key: "total_refundRatePercent" },
  { header: "Refunds", accessor: "refunds", total_key: "total_refunds" },
  { header: "Profit", accessor: "profit", total_key: "total_profit" },
  { header: "%PL", accessor: "PLper", total_key: "total_PLper" },
  { header: "PL/Client", accessor: "plClient", total_key: "total_plClient" },
  { header: "PL/Mail", accessor: "plMail", total_key: "total_plMail" },
  { header: "Turnover/Mail", accessor: "turnoverMail", total_key: "total_turnoverMail" },
  { header: "Cost/Mail", accessor: "costMail", total_key: "total_costMail" },
  { header: "Be Mlg Qty", accessor: "beMlgQty", total_key: "total_beMlgQty" },
  { header: "Be Orders", accessor: "be_orders", total_key: "total_be_orders" },
  { header: "LTV FE P/L per Buyer", accessor: "fe_p_l_ltv1", total_key: "total_fe_p_l_ltv1" },
  { header: "LTV BE PL per Buyer", accessor: "ltv_be_pl_per_buyer", total_key: "total_ltv_be_pl_per_buyer" },
  { header: "LTV Net PL per Buyer", accessor: "ltv_net_pl_per_buyer", total_key: "total_ltv_net_pl_per_buyer" },
];

const ResultsPerCategory = ({ processedData, loading }) => {

  return (
    <div className="d-flex flex-column gap-2">
      <CustomTable
        columns={ResultsPerCategoryColumns}
        data={processedData?.results_per_category?.data || []}
        totalAggregatedData={processedData?.results_per_category?.totals || {}}
        loading={loading}
        storageKey={"resultspercategory"}
      />
      <Comments tab_name="Results per category" />
    </div>
  );
};

export default ResultsPerCategory;
